/** Source key used for the catch-all / default document mapping. */
export const DEFAULT_DOC_TYPE_SOURCE = '_';
